import { TvvStandaardRoute, useGetTvvStandaardRoutesForStations } from "@/entities/tvv";
import { useBestelTVVRoutes } from "@/features/tvv/components/regievoerder/bestel-routes-context.ts";
import { RouteSelectItem } from "@/features/tvv/components/shared/route-select-item.tsx";
import { Empty, EmptyDescription, EmptyHeader, EmptyImage, ErrorDisplay } from "@/shared/components";

type GevondenRoutesProps = {
    dossierId: string;
    stations: string[];
};

export function GevondenRoutes({ dossierId, stations }: GevondenRoutesProps) {
    const { makeRouteAvailable, isAlreadyAdded, isAlreadyBesteld } = useBestelTVVRoutes();
    const {
        data: routes,
        error,
        isEnabled,
    } = useGetTvvStandaardRoutesForStations(dossierId, stations, {
        select: (routes: TvvStandaardRoute[]) => routes.filter((r) => !isAlreadyBesteld(r.routeId)),
    });

    if (error) {
        return <ErrorDisplay error={error} />;
    }

    if (isEnabled && routes?.length === 0) {
        return (
            <Empty>
                <EmptyImage variant="search" />
                <EmptyHeader className="flex justify-center font-normal">
                    <EmptyDescription className="text-s text-content-subtle">
                        Er zijn geen routes waar deze stations in voorkomen
                    </EmptyDescription>
                </EmptyHeader>
            </Empty>
        );
    }

    if (!routes) {
        return (
            <Empty>
                <EmptyImage variant="tracks" />
                <EmptyHeader className="flex justify-center font-normal">
                    <EmptyDescription className="text-s text-content-subtle">
                        Zoek op een of meer stations om routes te vinden
                    </EmptyDescription>
                </EmptyHeader>
            </Empty>
        );
    }

    return (
        <>
            {routes.map((route) => (
                <RouteSelectItem
                    key={route.routeId}
                    type="button"
                    route={route}
                    onAdd={(route) => makeRouteAvailable(route, true)}
                    isAdded={isAlreadyAdded(route.routeId)}
                />
            ))}
        </>
    );
}
